// extracted by mini-css-extract-plugin
export default {"dutiesMessage":"_f6776342","infoCircle":"_8fd8e58f","wrapper":"_2c3731c0"};